// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11wY3","question":"styles_question__3_wDq","description":"styles_description__1-G_-"};